<template>
  <div class="containerTable">
    <!-- 平台车辆列表 -->
    <vxe-toolbar
      :id="toolbarId"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button v-if="getLimit('vehicle_search_button')" @click="funcFilter"
          >查询</el-button
        >
        <el-button
          v-if="getLimit('vehicle_export_button') && !isLight"
          @click="funcExport"
          >导出</el-button
        >
        <el-button
          v-if="getLimit('vehicle_registerVehicle_button') && !isLight"
          @click="funcRecord"
          >批量备案</el-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      :key="tableKey"
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      height="80%"
      :data="tableData"
      :checkbox-config="{ highlight: true }"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <!-- <vxe-table-column>
        <vxe-table-column
          field="teamName"
          title="车队名称"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.teamName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column> -->
      <vxe-table-column v-if="isLight">
        <vxe-table-column
          field="gpsNo"
          title="GPS设备号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="listQuery.gpsNo" placeholder="请输入" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="authStatusExt"
          title="审核状态"
          :formatter="formatterAuthStatus"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.authStatusExt"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in authStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="isDeleted"
          title="车辆状态"
          :formatter="formatterDelete"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.deleted" placeholder="请选择">
            <el-option
              v-for="item in deletedOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="loadStatus"
          title="载重状态"
          :formatter="formatterLoadStatus"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.loadStatus"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in loadStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverName"
          title="驾驶员姓名"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverName"
            placeholder="请输入驾驶员姓名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverPhone"
          title="联系方式"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverPhone"
            placeholder="请输入联系方式"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="licenseNumber"
          title="车辆牌照号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.licenseNumber"
            placeholder="请输入车辆牌照号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="classificationCode"
          title="车辆类型"
          :formatter="formatterVehicleClassification"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.classificationCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in vehicleClassification"
              :key="item.code"
              :label="item.name"
              :value="item.code"
              clearable
            />
          </el-select>
        </template>
      </vxe-table-column>
      <!-- TODO:  start-->
      <!-- 挂车车牌号 -->
      <vxe-table-column v-if="!isLight">
        <vxe-table-column
          field="trailerNum"
          title="挂车车牌号"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.trailerNum"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>

      <!-- 挂车车辆类型   -->
      <vxe-table-column v-if="!isLight">
        <vxe-table-column
          field="trailerClassificationCode"
          title="挂车车辆类型"
          min-width="200"
          :formatter="formatterTrailerClassification"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.trailerClassificationCode"
            placeholder="请选择"
            clearable
            filterable
          >
            <el-option
              v-for="item in vehicleClassification"
              :key="item.code"
              :label="item.name"
              :value="item.code"
              clearable
            />
          </el-select>
        </template>
      </vxe-table-column>
      <!-- 挂车车长 -->
      <vxe-table-column>
        <vxe-table-column
          field="carLength"
          title="车长"
          min-width="200"
          :formatter="formatterTrailerCarLength"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.carLength"
            placeholder="请选择"
            clearable
            filterable
          >
            <el-option
              v-for="item in vehicleLength"
              :key="item.code"
              :label="item.name"
              :value="item.code"
              clearable
            />
          </el-select>
        </template>
      </vxe-table-column>

      <!-- TODO: end -->
      <!-- 总质量 -->
      <vxe-table-column>
        <vxe-table-column
          field="totalWeight"
          title="总质量车头整备质量(kg)"
          min-width="240"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.totalWeightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.totalWeightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <!-- 装卸质量 -->
      <vxe-table-column>
        <vxe-table-column
          field="loadWeight"
          title="核定载质量/准牵引总质量(kg)"
          min-width="240"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.loadWeightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.loadWeightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>

      <!-- <vxe-table-column>
        <vxe-table-column
          field="driverIsFreezeExt"
          title="是否冻结"
          :formatter="formatterIsFreeze"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.driverIsFreezeExt" placeholder="请选择" clearable>
            <el-option
              v-for="item in isFreezeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column> -->
      <!-- 编号start -->
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLicense"
          title="车辆行驶证档案编号"
          min-width="180"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleLicense"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- 编号end -->
      <!-- 车辆行驶证到期日期 -->
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLicenseDueDate"
          title="车辆行驶证到期日期"
          min-width="280"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="vehicleLicenseDueTime"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changevehicleLicenseDueDate(value)"
          />
        </template>
      </vxe-table-column>
      <!-- 道路运输证 -->
      <vxe-table-column>
        <vxe-table-column
          field="roadTransportCertificateNumber"
          title="道路运输证"
          min-width="180"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.roadTransportCertificateNumber"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- 许可证号 -->
      <vxe-table-column>
        <vxe-table-column
          field="roadPermitNumber"
          title="许可证号"
          min-width="180"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.roadPermitNumber"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- 道路运输证到期日期  periodValidity-->
      <vxe-table-column>
        <vxe-table-column
          field="roadTransportCertificateDate"
          title="道路运输证到期日期"
          min-width="280"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="roadTransportCertificateTime"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </template>
      </vxe-table-column>
      <!-- 是否牵引车 -->
      <vxe-table-column v-if="!isLight">
        <vxe-table-column
          field="isHasTrailer"
          title="是否牵引车"
          :formatter="
            ({ cellValue }) => formatterTrailer(cellValue, 'isHasTrailer')
          "
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isHasTrailer"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in etcStatusExtOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <!-- 4.5吨以下 -->
      <vxe-table-column v-if="!isLight">
        <vxe-table-column
          field="isLightTruck"
          title="4.5吨以下"
          :formatter="
            ({ cellValue }) => formatterTrailer(cellValue, 'isLightTruck')
          "
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isLightTruck"
            placeholder="请选择"
            clearable
            :disabled="isLight"
          >
            <el-option
              v-for="item in etcStatusExtOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <!--  -->
      <vxe-table-column>
        <vxe-table-column
          field="etcStatusExt"
          title="是否备案"
          :formatter="
            ({ cellValue }) => formatterOptions(cellValue, 'etcStatusExt')
          "
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.etcStatusExt"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in etcStatusExtOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="locationSource"
          title="定位来源"
          :formatter="formatterLocationSource"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.locationSource"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in locationSourceList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
              clearable
            />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="创建时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          v-if="isCtms"
          field="netStatus"
          :formatter="formatterNetStatus"
          title="车辆入网"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.netStatus"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in netStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <!-- 审核人 -->
      <vxe-table-column>
        <vxe-table-column
          field="auditor"
          title="审核人"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.auditor"
            placeholder="请输入审核人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" fixed="right" width="250">
        <template slot-scope="scope">
          <template v-if="!isLight">
            <el-tooltip
              v-if="getLimit('vehicle_detail_button')"
              effect="dark"
              content="详情"
              placement="top"
            >
              <vxe-button type="text" @click="funcDetail(scope.row.code)">
                <em class="el-icon-document" />
              </vxe-button>
            </el-tooltip>

            <el-tooltip
              v-if="getLimit('vehicle_edit_detail_button')"
              class="item"
              effect="dark"
              content="编辑"
              placement="top"
            >
              <vxe-button
                type="text"
                @click="funcEdit(scope.row.code, scope.row.partyCode)"
              >
                <em class="el-icon-edit" />
              </vxe-button>
            </el-tooltip>
            <el-tooltip
              v-if="getLimit('vehicle_vehicleTrail_button')"
              effect="dark"
              content="车辆定位"
              placement="top"
            >
              <vxe-button type="text" @click="funcVehicleTrail(scope.row.code)">
                <em class="el-icon-location-information" />
              </vxe-button>
            </el-tooltip>
            <el-tooltip
              v-if="
                getLimit('vehicle_registerVehicle_button') &&
                  scope.row.authStatusExt == 3
              "
              effect="dark"
              content="车辆备案"
              placement="top"
            >
              <vxe-button type="text" @click="registerVehicle(scope.row)">
                <em class="el-icon-folder-add" />
              </vxe-button>
            </el-tooltip>
            <!-- 操作日志 -->
            <el-tooltip
              v-if="getLimit('vehicle_logVehicle_button')"
              effect="dark"
              content="操作日志"
              placement="top"
            >
              <vxe-button type="text" @click="handleOperLog(scope.row)">
                <em class="el-icon-s-order" />
              </vxe-button>
            </el-tooltip>
            <!-- 删除 -->
            <el-tooltip
              v-if="
                scope.row.isDeleted === 0 && getLimit('vehicle_delete_button')
              "
              class="item"
              effect="dark"
              content="删除"
              placement="top"
            >
              <vxe-button type="text" @click="deleteCar(scope.row)">
                <em class="el-icon-delete" />
              </vxe-button>
            </el-tooltip>
          </template>
          <template v-if="isLight">
            <el-tooltip effect="dark" content="详情" placement="top">
              <vxe-button type="text" @click="funcDetail(scope.row.code)">
                <em class="el-icon-document" />
              </vxe-button>
            </el-tooltip>
            <el-tooltip
              v-if="!scope.row.gpsCode"
              class="item"
              effect="dark"
              content="绑定GPS"
              placement="top"
            >
              <vxe-button type="text" @click="bindLightVehicle(scope.row)">
                <!-- <em class="el-icon-link" /> -->
                <img
                  style="width: 19px; height: 19px;position: relative;top:5px;"
                  src="@/assets/icon/bangding.png"
                  alt=""
                />
              </vxe-button>
            </el-tooltip>
            <el-tooltip
              v-if="scope.row.gpsCode"
              class="item"
              effect="dark"
              content="解绑GPS"
              placement="top"
            >
              <vxe-button type="text" @click="unbindVehicleApi(scope.row)">
                <!-- <em class="el-icon-paperclip" /> -->
                <img
                  style="width: 18px; height: 18px;position: relative;top:5px;"
                  src="@/assets/icon/jiebang.png"
                  alt=""
                />
              </vxe-button>
            </el-tooltip>
            <el-tooltip
              v-if="scope.row.gpsCode"
              effect="dark"
              content="查看轨迹"
              placement="top"
            >
              <vxe-button
                type="text"
                @click="historyTrackByGpsNoApi(scope.row)"
              >
                <em class="el-icon-location-information" />
              </vxe-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="操作记录" placement="top">
              <vxe-button type="text" @click="handleOperLog({ ...scope.row })">
                <em class="el-icon-s-order" />
              </vxe-button>
            </el-tooltip>
          </template>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />

    <vxe-modal
      v-model="modelDetailFlag"
      title="详情"
      width="1400"
      height="800"
      resize
    >
      <compDetail
        ref="detailRef"
        :parent-data="{
          isDetail,
          vehicleClassificationList,
          vehicleLengthList,
          vehicleWidthList,
          vehicleHighList,
          vehicleTonnageList,
          locationSourceList,
          vehicleLicenseColorList,
          vehicleEnergyTypeList,
          vehicleClassification
        }"
      />
    </vxe-modal>
    <vxe-modal
      v-model="modelVehicleTrailFlag"
      title="车辆定位"
      width="900"
      height="80%"
      resize
    >
      <compVehicleTrail ref="vehicleTrailRef" />
    </vxe-modal>
    <vxe-modal
      v-model="Printingxianyin"
      title="打印"
      width="900"
      height="80%"
      resize
    >
      <Printinging ref="dayinRef" />
    </vxe-modal>
    <!--  操作日志  -->
    <vxe-modal
      v-model="isLogList"
      title="操作日志"
      width="900"
      height="700"
      resize
    >
      <LogList v-if="isLogList" :row-info="rowInfo" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
    <!-- 绑定车辆弹窗 -->
    <vxe-modal
      v-model="modelBindLightVehicleFlag"
      title="绑定GPS"
      width="600"
      height="200"
      resize
    >
      <compBindLightVehicle
        v-if="modelBindLightVehicleFlag"
        :row-info-item="rowInfoItem"
        @close="findList"
      />
    </vxe-modal>
    <vxe-modal
      v-model="positionFlag"
      title="运单轨迹"
      width="88%"
      height="96%"
      resize
      remember
      @close="positionFlag = false"
    >
      <Position
        :is-light-type="true"
        :light-track-list="lightTrackList"
        :positoin-info="positoinInfo"
      />
    </vxe-modal>
  </div>
</template>
<script>
import compBindLightVehicle from "./components/compBindLightVehicle.vue";
import LogList from "./components/LogList.vue";
import driverEdit from "@/views/basicInfo/driver/driverManage/components/driverEdit.vue";
import compDetail from "./components/vehicleDetail.vue";
import Printinging from "./components/Printing.vue";
import compVehicleTrail from "./components/vehicleTrail.vue";
import { vehicle, deleteVehicle } from "@/api/transport";
import { unbindVehicle, historyTrackByGpsNo } from "@/api/gps";
import {
  freezeDriver,
  unfreezeTeamDriver,
  registerVehicle,
  registerVehicles
} from "@/api/driver";
import { getListDict } from "@/api/commonApi";
import { getRole } from "@/utils/getRole";
import Position from "@/views/tms/transportManage/waybillManage/components/components/Position.vue";
export default {
  name: "PlatVehicle",
  components: {
    compDetail,
    Position,
    compVehicleTrail,
    Printinging,
    driverEdit,
    LogList,
    compBindLightVehicle
  },
  data() {
    return {
      lightTrackList: [],
      positionFlag: false,
      positoinInfo: {},
      rowInfoItem: {},
      modelBindLightVehicleFlag: false,
      isLogList: false,
      rowInfo: {},
      roadTransportCertificateTime: [],
      vehicleLicenseDueTime: [],
      vehicleLength: [],
      exportObj: {
        exportUrl: "/ntocc-basic-api/vehicle/exportVehicleList", //导出接口
        name: "平台车辆"
      },
      isCtms: true, //默认显示  同城系统隐藏
      Printingxianyin: false,
      loading: false,
      tableData: [],
      modelDetailFlag: false,
      modelVehicleTrailFlag: false,
      listQuery: {
        gmtCreatedRange: "",
        branchCodeExt: "",
        code: "",
        licenseNumber: "",
        driverPhone: "",
        branchCode: "",
        teamCode: "",
        licensePlateType: "",
        classificationCode: "",
        roadTransportCertificateNumber: "",
        roadTransportCertificateImg: "",
        roadTransportCertificateDate: "",
        loadWeight: "",
        loadVolume: "",
        remainingLoadWeight: "",
        remainingLoadVolume: "",
        vehicleLicenseColor: "",
        vehicleLicenseImg: "",
        vehicleLicenseDueDate: "",
        vehicleImg: "",
        isHasTrailer: "",
        trailerNum: "",
        trailerVehicleLicenseImg: "",
        trailerRoadTransport: "",
        trailerRoadTransportCertificateImg: "",
        trailerVehicleImg: "",
        authStatus: "",
        authStatusExt: "",
        loadStatus: "",
        isFreeze: "",
        locationSource: "",
        terminalNumber: "",
        driverIsFreeze: "",
        driverIsFreezeExt: "",
        etcStatusExt: "",
        pageNum: 1,
        pageSize: 20,
        total: 0,
        deleted: 2
      },
      isDetail: true,
      vehicleClassificationList: [],
      vehicleClassification: [],
      vehicleLengthList: [],
      vehicleWidthList: [],
      vehicleHighList: [],
      vehicleTonnageList: [],
      locationSourceList: [],
      vehicleEnergyTypeList: [],
      vehicleLicenseColorList: [],
      // 载重状态
      loadStatusOptions: [
        {
          label: "空载",
          value: 0
        },
        {
          label: "负载",
          value: 1
        }
      ],
      // 审核状态
      authStatusOptions: [
        {
          label: "未审核",
          value: 0
        },
        { label: "审核中", value: 1 },
        {
          label: "审核驳回",
          value: 2
        },
        {
          label: "审核通过",
          value: 3
        }
      ],
      // 是否冻结
      isFreezeOptions: [
        {
          label: "未冻结",
          value: 0
        },
        {
          label: "已冻结",
          value: 1
        }
      ],
      // 是否冻结
      etcStatusExtOptions: [
        {
          label: "否",
          value: "0"
        },
        {
          label: "是",
          value: "1"
        }
      ],
      // 是否入网
      netStatusOptions: [
        {
          label: "未入网",
          value: 0
        },
        {
          label: "已入网",
          value: 1
        }
      ],
      deletedOptions: [
        {
          label: "正常",
          value: 0
        },
        {
          label: "已注销",
          value: 1
        },
        {
          label: "全部",
          value: 2
        }
      ]
    };
  },
  computed: {
    isLight() {
      return this.$route.path.includes("lightVehicle");
    },
    toolbarId() {
      const path = (this.$route.path || "").replace(/\//g, "_");
      return `toolbar_vehicleList${path ? "_" + path : ""}`;
    },
    tableKey() {
      return `vehicleList_table_${(this.$route.fullPath || "").replace(
        /[/?=&]/g,
        "_"
      )}`;
    }
  },
  watch: {
    // 仅车辆相关路由之间切换时重置；离开/返回不重置，保留 keep-alive 状态
    "$route.fullPath": {
      handler(newVal, oldVal) {
        if (newVal === oldVal) return;
        const isVehiclePath = (p = "") =>
          /lightVehicle/i.test(p) || /(^|\/)vehicle(\/|$)/i.test(p);
        if (!isVehiclePath(newVal)) return;
        if (oldVal != null && !isVehiclePath(oldVal)) return;

        this.listQuery = {
          pageNum: 1,
          pageSize: 20,
          total: 0,
          deleted: 2,
          isLightTruck: this.isLight ? "1" : null
        };
        this.$nextTick(() => {
          const table = this.$refs.xTable;
          if (!table) return;
          if (table.clearSort) table.clearSort();
          if (table.clearCheckboxRow) table.clearCheckboxRow();
        });
        this.findList();
      }
    }
  },
  created() {
    if (this.$route.meta) {
      this.$route.meta.keepLive = true;
    }
    if (this.isLight) {
      this.listQuery.isLightTruck = "1";
    }
    this.checkList(() => {
      this.findList();
    });

    // 获取数据字典： 车型，车长，车宽，车高，吨位，定位来源，车牌颜色 app_vehicleLength,app_vehicleClassification

    this.isCtms = !getRole();
    this.listQuery.branchCodeExt = JSON.parse(
      localStorage.getItem("dataBranch")
    ).code;
  },
  methods: {
    historyTrackByGpsNoApi(item) {
      historyTrackByGpsNo({
        gpsNo: item.gpsNo
      }).then(res => {
        if (res.status === 0) {
          this.positoinInfo = {
            vehicleLicense: item.vehicleLicense || "",
            fillTime: "",
            signTime: ""
          };
          this.lightTrackList = res.data;
          if (this.lightTrackList && this.lightTrackList.length > 0) {
            this.positionFlag = true;
          } else {
            this.positionFlag = false;
            this.lightTrackList = [];
            this.$message({
              message: "该设备暂无定位信息",
              type: "warning",
              duration: 1500
            });
          }
        }
      });
    },
    unbindVehicleApi(item) {
      this.$confirm("确定解绑该车辆吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        unbindVehicle({
          code: item.gpsCode
        }).then(res => {
          if (res.status === 0) {
            this.$message({
              message: "解绑成功",
              type: "success"
            });
            this.findList();
          }
        });
      });
    },
    bindLightVehicle(item) {
      this.rowInfoItem = item;
      this.modelBindLightVehicleFlag = true;
    },
    deleteCar(row) {
      this.$confirm("确定删除该车辆吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        deleteVehicle({
          codes: row.code
        })
          .then(response => {
            if (response.status === 0) {
              this.$message({
                message: "删除成功",
                type: "success"
              });
              this.findList();
            }
          })
          .catch(call => {});
      });
    },
    handleOperLog(item) {
      if (!item.gpsCode && this.isLight) {
        this.$message.error("未绑定GPS,不能查看操作记录");
        return;
      }
      this.rowInfo = {
        ...item,
        reviewGpsCode: this.isLight ? item.gpsCode : ""
      };
      this.isLogList = true;
      console.log("操作日志=====", item);
    },
    checkList(callback) {
      getListDict({
        types:
          "app_vehicleClassification,app_vehicleLength,vehicleClassification,vehicleWidth,vehicleHigh,vehicleTonnage,locationSource,vehicleEnergyType,vehicleLicenseColor,vehicleLength"
      }).then(response => {
        this.vehicleLength = response.data.filter(
          item => item.type === "vehicleLength"
        )[0]["dictList"];
        this.vehicleClassificationList = response.data.filter(
          item => item.type === "app_vehicleClassification"
        )[0]["dictList"];
        this.vehicleClassification = response.data.filter(
          item => item.type === "vehicleClassification"
        )[0]["dictList"];
        this.vehicleLengthList = response.data.filter(
          item => item.type === "app_vehicleLength"
        )[0]["dictList"];
        this.vehicleWidthList = response.data.filter(
          item => item.type === "vehicleWidth"
        )[0]["dictList"];
        this.vehicleHighList = response.data.filter(
          item => item.type === "vehicleHigh"
        )[0]["dictList"];
        this.vehicleTonnageList = response.data.filter(
          item => item.type === "vehicleTonnage"
        )[0]["dictList"];
        this.locationSourceList = response.data.filter(
          item => item.type === "locationSource"
        )[0]["dictList"];
        this.vehicleEnergyTypeList = response.data.filter(
          item => item.type === "vehicleEnergyType"
        )[0]["dictList"];
        this.vehicleLicenseColorList = response.data.filter(
          item => item.type === "vehicleLicenseColor"
        )[0]["dictList"];
        callback && callback();
      });
    },
    changevehicleLicenseDueDate(value) {
      console.log("changevehicleLicenseDueDate", value);
    },
    // 设置重量小数点后三位
    setkey(value, key) {
      this.$set(this.listQuery, key, value.replace(/\.[0-9]+/, ""));
    },
    findList() {
      this.loading = true;
      this.modelBindLightVehicleFlag = false;
      return new Promise(resolve => {
        console.log(
          "查询条件========",
          this.listQuery.roadTransportCertificateDate,
          this.listQuery.vehicleLicenseDueDate
        );
        if (
          this.roadTransportCertificateTime &&
          this.roadTransportCertificateTime.length
        ) {
          this.listQuery.roadTransportCertificateDateStart = this.roadTransportCertificateTime[0];
          this.listQuery.roadTransportCertificateDateEnd = this.roadTransportCertificateTime[1];
        } else {
          this.listQuery.roadTransportCertificateDateStart = "";
          this.listQuery.roadTransportCertificateDateEnd = "";
        }
        if (this.vehicleLicenseDueTime && this.vehicleLicenseDueTime.length) {
          this.listQuery.vehicleLicenseDueDateStart = this.vehicleLicenseDueTime[0];
          this.listQuery.vehicleLicenseDueDateEnd = this.vehicleLicenseDueTime[1];
        } else {
          this.listQuery.vehicleLicenseDueDateStart = "";
          this.listQuery.vehicleLicenseDueDateEnd = "";
        }
        this.listQuery.isMasterBind = 1;
        vehicle(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    // 批量上传
    funcBatchUp() {
      this.checkedRowArray = this.$refs.xTable.getSelectRecords();
      if (!this.checkedRowArray || this.checkedRowArray.length === 0) {
        this.$message({
          message: "请选择要上传的车辆",
          type: "warning"
        });
      } else {
        this.$message({
          message: "上传成功",
          type: "success"
        });
        // const checkCodeArray = []
        // this.checkedRowArray.forEach(item => {
        //   checkCodeArray.push(item.partyCode)
        // })
        // const checkPartyCodes = checkCodeArray.join(',')
        // request({ url: '/ntocc-tms-api/', method: 'post', params: { teamCodes: checkPartyCodes }}).then(response => {
        //   this.$message({ message: '上传成功', type: 'success' })
        //   this.findList()
        // })
      }
    },
    funcEdit(code, partyCode) {
      this.$router.push({
        path: "/driver/editDriverCarForm",
        query: { code, partyCode, isDetail: 0 }
      });
    },
    // funcEdit(code) {
    //   this.$refs.detailRef.getInfo(code, "edit");
    //   this.modelDetailFlag = true;
    // },
    // 详情方法
    funcDetail(code) {
      this.$refs.detailRef.getInfo(code, "detail");
      this.modelDetailFlag = true;
    },
    //打印
    Printing(code, licenseNumber) {
      this.$refs.dayinRef.getInfo(code, licenseNumber);
      this.Printingxianyin = true;
    },
    // 车辆历史跟踪方法
    funcVehicleTrail(code) {
      this.$refs.vehicleTrailRef.trajectory(code);
      this.modelVehicleTrailFlag = true;
    },
    // 冻结
    lockCar(row) {
      this.$confirm("确认冻结吗？")
        .then(_ => {
          freezeDriver({
            partyCode: row.partyCode
          }).then(response => {
            this.$message({
              message: response.msg,
              type: "success"
            });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    // 解除冻结
    unlockCar(row) {
      this.$confirm("确认解除冻结吗？")
        .then(_ => {
          unfreezeTeamDriver({
            partyCode: row.partyCode
          }).then(response => {
            this.$message({
              message: response.msg,
              type: "success"
            });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    // 翻译审核状态
    formatterAuthStatus({ cellValue }) {
      const item = this.authStatusOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    // 翻译车型
    formatterVehicleClassification({ cellValue }) {
      const item = this.vehicleClassification.find(
        item => item.code === cellValue
      );
      return item ? item.name : "";
    },
    formatterTrailerClassification({ cellValue }) {
      const item = this.vehicleClassification.find(
        item => item.code === cellValue
      );
      return item ? item.name : "";
    },
    formatterTrailerCarLength({ cellValue }) {
      const item = this.vehicleLengthList.find(item => item.code === cellValue);
      return item ? item.name : "";
    },
    // 翻译载重状态
    formatterLoadStatus({ cellValue }) {
      const item = this.loadStatusOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    formatterDelete({ cellValue }) {
      const item = this.deletedOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    // 翻译是否冻结
    formatterIsFreeze({ cellValue }) {
      const item = this.isFreezeOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    // 翻译定位来源
    formatterLocationSource({ cellValue }) {
      const item = this.locationSourceList.find(item => item.code == cellValue);
      return item ? item.name : "";
    },
    // 翻译是否入网
    formatterNetStatus({ cellValue }) {
      const item = this.netStatusOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    formatterTrailer(cellValue, prefix) {
      let arr = [
        {
          value: 0,
          label: "否"
        },
        {
          value: 1,
          label: "是"
        }
      ];
      const item = arr.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    // 翻译
    formatterOptions(cellValue, prefix) {
      const item = this[`${prefix}Options`].find(
        item => item.value == cellValue
      );
      return item ? item.label : "";
    },
    //车辆备案
    registerVehicle(row) {
      this.$confirm("确认备案该车辆（ETC）？")
        .then(_ => {
          registerVehicle({
            num: row.licenseNumber
          }).then(response => {
            this.$message({
              message: response.msg,
              type: "success"
            });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    funcRecord() {
      let selectRecords = this.$refs.xTable.getCheckboxRecords();
      if (!selectRecords || selectRecords.length == 0) {
        this.$message({
          message: "请选择备案车辆!",
          type: "warning"
        });
        return false;
      }
      for (let i = 0; i < selectRecords.length; i++) {
        // if (selectRecords[i].etcStatusExt == 1) {
        // 	this.$message({
        // 		message: '所选车辆包含已备案车辆，请重新选择!',
        // 		type: 'warning'
        // 	})
        // 	return false;
        // }
        if (selectRecords[i].authStatusExt != 3) {
          this.$message({
            message: "所选车辆包含未审核通过车辆，请重新选择!",
            type: "warning"
          });
          return false;
        }
      }
      const rLoading = this.openLoading();
      let vehicleNum = selectRecords.map(item => item.licenseNumber).join(",");
      registerVehicles({
        nums: vehicleNum
      }).then(response => {
        this.$message({
          message: response.msg,
          type: "success"
        });
        this.findList();
        rLoading.close();
      });
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "add":
          this.modelAddFlag = false;
          break;
        case "edit":
          this.modelEditFlag = false;
          break;
        case "detail":
          this.modelDetailFlag = false;
          break;
        default:
      }
    }
  }
};
</script>
